export default __webpack_public_path__ + "246fe63e8e4e534e79454f89f2e1a079.jpg";